import { BackButton, Header, Loader } from "@egovernments/digit-ui-react-components";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { convertEpochToDateDMY } from "../../../utils";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import { Box, Button, Card, Tab, Tabs, TextField, InputAdornment, IconButton, Popover, Typography, FormControlLabel, Checkbox } from "@mui/material";
import DialogContentModal from "../../../../../templates/ApplicationDetails/components/DialogContent";
import ApplicationView12 from "../../../../../templates/Forms/Form12/Application12View";
import useDepartmentSelector from "../TCPForms/hooks/useDepartmentSelector";
import SearchSummary from "../AVPForms/formComponents/map-submission/Summary/SearchSummary";
import { PrimaryTab, PrimaryTabs, PrimaryTabsWrapper } from "../AVPForms/components/StyledComponent";
import MigratedSummary from "./MigratedSummary";
import ClearIcon from "@mui/icons-material/Clear";
import { ArrowDownward } from "@mui/icons-material";
import FilterListIcon from "@mui/icons-material/FilterList";
import SearchIcon from "@mui/icons-material/Search";

const CompoundingApplications = () => {
  const { t } = useTranslation();
  const citizenBaseUrl = "/digit-ui/citizen";

  const history = useHistory();
  const [smShowMs, setSmShowMs] = useState(false);
  const [showMs, setshowMs] = useState(false);
  const [idData, setIdData] = useState("");
  const [formType, setFormType] = useState("");
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const userInfo = Digit.UserService.getUser()?.info || {};
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [globalSearch, setGlobalSearch] = useState("");
  const [selectedAction, setSelectedAction] = useState("All");
  const [currentpage, setCurentPage] = React.useState(0);

  const applicationType = "FORM_COMPOUNDING";
  const [tabIndex, setTabIndex] = useState(0);
  const [migratedData, setMigratedData] = useState(null);
  const limit = rowsPerPage;
  const [isUdFlow, applicationFlow, DepartmentSelector] = useDepartmentSelector();
  const departement = applicationFlow;
  const mobileNumber = userInfo?.mobileNumber;
  const { data, isLoading: loader, refetch } = Digit.Hooks.obps.useBPADetailsPage(
    tenantId,
    {
      applicationType: "FORM_COMPOUNDING",
      pageNumber: currentpage + 1,
      pageSize: rowsPerPage,
      ...(selectedAction !== "All" && { action: selectedAction }),
    },
    { formType: "MAP_SUB" }
  );
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedColumns, setSelectedColumns] = useState([
    "srNo",
    "name",
    "mobileNumber",
    "applicationNo",
    "applicationType",
    "applicationDate",
    "status",
    "action"
  ]);
  // State for filters
  const [filters, setFilters] = useState({
    name: "",
    mobileNumber: "",
    applicationNo: "",
    applicationType: "",
    status: "",
  });
  const handleObjectionLetter = (item) => {
    console.log("itemfromFunctionLetter", item);

    const objectionKey = Object.keys(item?.objectionLetterUrl).find((key) => key.startsWith("objection_"));
    const objectionLetterUrl = item?.objectionLetterUrl[objectionKey];
    window.open(objectionLetterUrl, "_blank");
  };
  // Handle filter change
  const handleFilterChange = (property, value) => {
    setFilters({
      ...filters,
      [property]: value,
    });
    setPage(0);
  };

  // Handle clear filter
  const handleClearFilter = (property) => {
    setFilters({
      ...filters,
      [property]: "",
    });
  };

  async function fetchMigratedData() {
    try {
      const response = await Digit.OBPSService.BPAmigratedSearch({ mobileNumber });
      setMigratedData(response?.ApplicationList);
    } catch (error) {
      console.error("Error fetching migrated data:", error);
    }
  }

  useEffect(() => {
    fetchMigratedData();
  }, []);

  const handleActionChange = (action) => {
    setSelectedAction(action);
    setCurentPage(0); // Reset to first page when action changes
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const [page, setPage] = React.useState(0);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  React.useEffect(() => {
    refetch();
  }, [currentpage, rowsPerPage, refetch, page, selectedAction]);
  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  useEffect(() => {
    Digit.SessionStorage.del("OWNER_INFO");
    Digit.SessionStorage.del("FASTPAS_ID");
    Digit.SessionStorage.del("FILE_NO");
  }, []);

  const StyleTabelCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#1f4a7c",
      color: theme.palette.common.white,
      fontSize: 16,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
      color: theme.palette.common.white,
    },
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  function getApprovalLetter(item) {
    const pdfUrl = item?.compoundingApprovalLetterUrl;
    window.open(pdfUrl, "_blank");
  }

  function getRejectionLetter(item) {
    const pdfUrl = item?.compoundingRejectLetterUrl;
    window.open(pdfUrl, "_blank");
  }

  function getShortfallLetter(item) {
    const pdfUrl = item?.compoundingShortfallUrl;
    window.open(pdfUrl, "_blank");
  }

  function getInitiationLetter(item) {
    const pdfUrl = item?.farInimationLetterUrl;
    window.open(pdfUrl, "_blank");
  }

  const [orderBy, setOrderBy] = useState("applicationDate");
  const [order, setOrder] = useState("desc");

  // Improved sorting function
  const getComparator = (order, orderBy) => {
    return (a, b) => {
      const getValue = (item) => {
        switch (orderBy) {
          case "name":
            return item?.landInfo?.owners?.[0]?.name?.toLowerCase() || "";
          case "mobileNumber":
            return item?.landInfo?.owners?.[0]?.mobileNumber || "";
          case "applicationNo":
            return item?.applicationNo?.toLowerCase() || "";
          case "applicationType":
            return t(item?.applicationType)?.toLowerCase() || "";
          case "status":
            return t(`WF_BPA_MAP_${item?.status}`)?.toLowerCase() || "";
          case "applicationDate":
            return item?.auditDetails?.createdTime || 0;
          default:
            return "";
        }
      };

      const aValue = getValue(a);
      const bValue = getValue(b);

      if (order === "desc") {
        return bValue > aValue ? 1 : bValue < aValue ? -1 : 0;
      } else {
        return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
      }
    };
  };

  const handleSort = (column) => {
    const isAsc = orderBy === column && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(column);
  };
  const handleGlobalSearch = (value) => {
    setGlobalSearch(value);
    setPage(0);
  };
  const matchesSearch = (value, search) => {
    if (!value) return false;
    return value.toString().toLowerCase().includes(search.toLowerCase());
  };
  // Apply filtering
  const getFilteredData = () => {
    let filteredData = data?.BPA || [];
    if (globalSearch) {
      filteredData = filteredData?.filter((item) => {
        return (
          matchesSearch(item?.landInfo?.owners?.[0]?.name, globalSearch) ||
          // matchesSearch(item?.plotArea, globalSearch) ||
          matchesSearch(item?.landInfo?.owners?.[0]?.mobileNumber, globalSearch) ||
          matchesSearch(item?.applicationNo, globalSearch) ||
          matchesSearch(item?.applicationType, globalSearch) ||
          matchesSearch(item?.status, globalSearch) ||
          matchesSearch(convertEpochToDateDMY(item?.auditDetails?.createdTime), globalSearch)
        );
      });
    }
    if (filters.name) {
      filteredData = filteredData.filter((item) => item?.landInfo?.owners?.[0]?.name?.toLowerCase().includes(filters.name.toLowerCase()));
    }

    if (filters.mobileNumber) {
      filteredData = filteredData.filter((item) => item?.landInfo?.owners?.[0]?.mobileNumber?.includes(filters.mobileNumber));
    }

    if (filters.applicationNo) {
      filteredData = filteredData.filter((item) => item?.applicationNo?.toLowerCase().includes(filters.applicationNo.toLowerCase()));
    }

    if (filters.applicationType) {
      filteredData = filteredData.filter((item) => t(item?.applicationType)?.toLowerCase().includes(filters.applicationType.toLowerCase()));
    }

    if (filters.status) {
      filteredData = filteredData.filter((item) => t(`WF_BPA_MAP_${item?.status}`)?.toLowerCase().includes(filters.status.toLowerCase()));
    }

    return filteredData;
  };

  const filteredData = getFilteredData();
  const sortedData = filteredData.slice().sort(getComparator(order, orderBy));
  const paginatedData = sortedData?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  const handleOpenColumnFilter = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseColumnFilter = () => {
    setAnchorEl(null);
  };
  const handleColumnToggle = (columnId) => {
    if (selectedColumns.includes(columnId)) {
      // Don't allow deselecting all columns - at least one must remain
      if (selectedColumns.length > 1) {
        setSelectedColumns(selectedColumns.filter((id) => id !== columnId));
      }
    } else {
      setSelectedColumns([...selectedColumns, columnId]);
    }
  };
  const allColumns = [
    {
      id: "srNo",
      label: "Sr No",
      filterable: false,
      width: "5%",
      renderCell: (item, index, page, rowsPerPage) => <td className="td-srno">{page * rowsPerPage + index + 1}</td>,
    },
    {
      id: "name",
      label: "Name",
      filterable: true,
      sortable: true,
      width: "12%",
      renderCell: (item) => <td className="td-name">{item?.landInfo?.owners?.[0]?.name || "-"}</td>,
    },
    {
      id: "mobileNumber",
      label: "Mobile No.",
      filterable: true,
      sortable: true,
      width: "10%",
      renderCell: (item) => <td className="td-mobile">{item?.landInfo?.owners?.[0]?.mobileNumber || "-"}</td>,
    },
    {
      id: "applicationNo",
      label: "Application No.",
      filterable: true,
      sortable: true,
      width: "10%",
      renderCell: (item) => (
        <td className="td-appno">
          <strong style={{ color: "#007bff", textDecoration: "none", cursor: "pointer" }} onClick={() => handleClickAction(item)}>
            {item?.applicationNo || "-"}
          </strong>
        </td>
      ),
    },
    {
      id: "applicationType",
      label: "Application Type",
      filterable: true,
      sortable: true,
      width: "10%",
      renderCell: (item) => <td className="td-apptype">{t(item?.applicationType) || "-"}</td>,
    },
    {
      id: "applicationDate",
      label: "Date",
      filterable: false,
      sortable: true,
      width: "10%",
      renderCell: (item) => <td className="td-date">{convertEpochToDateDMY(item?.auditDetails?.createdTime) || "-"}</td>,
    },
    {
      id: "status",
      label: "Status",
      filterable: true,
      sortable: true,
      width: "13%",
      renderCell: (item) => {
        const role = item?.assignes?.[0]?.roles?.find((role) => role.name !== "Employee")?.name;

        if (item?.assignes?.length > 0) {
          return <td className="td-status">{`Pending with [${role}] (${item?.assignes?.[0].name})`}</td>;
        }
        return <td className="td-status">{t(`WF_BPA_MAP_${item?.status}`) || "-"}</td>;
      },
    },
    {
      id: "resubmit",
      label: "Resubmit",
      filterable: false,
      sortable: false,
      width: "13%",
      renderCell: (item) => (
        <td className="td-resubmit">
          {["INITIATE", "UPLOAD_DOC", "REVERT_TO_APPLICANT"].includes(item?.status) && (
            <Button
              size="small"
              className="btn-table-action"
              variant="contained"
              color="primary"
              onClick={() =>
                history.push({
                  pathname: `/digit-ui/citizen/obps/services/edcrPortal/${item?.applicationId}`,
                  state: { applicationNumber: item?.applicationId },
                })
              }
            >
              <span>Resubmit</span>
            </Button>
          )}
        </td>
      ),
    },
    {
      id: "receipt",
      label: "Receipt",
      filterable: false,
      sortable: false,
      width: "13%",
      renderCell: (item) => (
        <td className="td-receipt">
          {item?.paymentStatus === "SUCCESS" && item?.taxHeadEstimates?.[0] && (
            <Button
              size="small"
              className="btn-table-action"
              variant="contained"
              color="primary"
              onClick={() => {
                window.localStorage.setItem("ApplicationStatus", item?.status);
                history.push({
                  pathname: `/digit-ui/citizen/obps/professional/payment/${item?.applicationNo}/${item?.tenantId}`,
                });
              }}
            >
              <span>Receipt</span>
            </Button>
          )}
        </td>
      ),
    },
    {
      id: "objectionLetter",
      label: "Objection Letter",
      filterable: false,
      sortable: false,
      width: "13%",
      renderCell: (item) => (
        <td className="td-objection">
          {item?.objectionLetterUrl && (
            <Button size="small" className="btn-table-action" variant="contained" color="primary" onClick={() => handleObjectionLetter(item)}>
              <span>View</span>
            </Button>
          )}
        </td>
      ),
    },
    {
      id: "proposalLetter",
      label: "Proposal Letter",
      filterable: false,
      sortable: false,
      width: "13%",
      renderCell: (item) => (
        <td className="td-proposal">
          {item?.proposalUrl && (
            <Button
              size="small"
              className="btn-table-action"
              variant="contained"
              color="primary"
              onClick={() => window.open(item?.proposalUrl, "_blank")}
            >
              <span>View</span>
            </Button>
          )}
        </td>
      ),
    },
    {
      id: "approvalLetter",
      label: "Approval Letter",
      filterable: false,
      sortable: false,
      width: "13%",
      renderCell: (item) => (
        <td className="td-approval">
          {(item?.compoundingApprovalLetterUrl) && (
            <Button size="small" className="btn-table-action" variant="contained" color="primary" onClick={() => getApprovalLetter(item)}>
              <span>View</span>
            </Button>
          )}
        </td>
      ),
    },
    {
      id: "Rejection Letter",
      label: "Rejection Letter",
      filterable: false,
      sortable: false,
      width: "13%",
      renderCell: (item) => (
        <td className="td-rejection">
          {item?.compoundingRejectLetterUrl && item?.taxHeadEstimates?.[0] && (
            <Button size="small" className="btn-table-action" variant="contained" color="primary" onClick={() => getRejectionLetter(item)}>
              <span>View</span>
            </Button>
          )}
        </td>
      ),
    },
    {
      id: "shortfallLetter",
      label: "Shortfall Letter",
      filterable: false,
      sortable: false,
      width: "13%",
      renderCell: (item) => (
        <td className="td-shortfall">
          {item?.compoundingShortfallUrl && item?.taxHeadEstimates?.[0] && (
            <Button size="small" className="btn-table-action" variant="contained" color="primary" onClick={() => getShortfallLetter(item)}>
              <span>View</span>
            </Button>
          )}
        </td>
      ),
    },
    {
      id: "initiationLetter",
      label: "Initiation Letter",
      filterable: false,
      sortable: false,
      width: "13%",
      renderCell: (item) => (
        <td className="td-initiation">
          {item?.farInimationLetterUrl && (
            <Button size="small" className="btn-table-action" variant="contained" color="primary" onClick={() => getInitiationLetter(item)}>
              <span>View</span>
            </Button>
          )}
        </td>
      ),
    },
    {
      id: "nocStatus",
      label: "NOC Status",
      filterable: false,
      sortable: false,
      width: "13%",
      renderCell: (item) => (
        <td className="td-noc">
          <Button
            size="small"
            className="btn-table-action"
            variant="contained"
            color="primary"
            onClick={() => {
              Digit.SessionStorage.set("nocAppData", item);

              history.push(`${citizenBaseUrl}/obps/nocApplications/${item?.applicationNo}`);
            }}
          >
            <span>View</span>
          </Button>
        </td>
      ),
    },
    {
      id: "action",
      label: "Action",
      filterable: false,
      sortable: false,
      width: "13%",
      renderCell: (item) => (
        <td className="td-action">
          {["INITIATE", "UPLOAD_DOC", "REVERT_TO_APPLICANT", "MAKE_PAYMENT_SELF", "WF_BPA_12_MAKE_PAYMENT_APPLICATION_FEE"].includes(item?.status) ? (
            <Button
              size="small"
              className="btn-table-action"
              variant="contained"
              color="primary"
              onClick={() => {
                window.localStorage.setItem("ApplicationStatus", item?.status);
                if (item.planOn === "SELF_MAP") {
                  history.push({
                    pathname: `/digit-ui/citizen/obps/services/selfResidentialPortal/${item?.applicationId}`,
                  });
                } else {
                  Digit.SessionStorage.set("nocAppData", item);
                  history.push({
                    pathname: `/digit-ui/citizen/obps/services/mapSubmissionPortal/${item?.applicationId}`,
                  });
                }
              }}
            >
              <span>Edit</span>
            </Button>
          ) : (
            <Button
              size="small"
              className="btn-table-action"
              variant="contained"
              color="success"
              onClick={() => {
                window.localStorage.setItem("ApplicationStatus", item?.status);
                Digit.SessionStorage.set("OWNER_INFO", item?.landInfo?.owners?.[0]?.name);
                Digit.SessionStorage.set("FASTPAS_ID", item);
                Digit.SessionStorage.set("FILE_NO", item?.applicationNo);
                history.push({
                  pathname: `/digit-ui/citizen/obps/structuralform12/${item?.applicationNo}`,
                });
              }}
            >
              <span>View</span>
            </Button>
          )}
        </td>
      ),
    },
  ];

  const columns = allColumns.filter((col) => selectedColumns.includes(col.id));

  const handleClickAction = (item) => {
    window.localStorage.setItem("ApplicationStatus", item?.status);
    Digit.SessionStorage.set("OWNER_INFO", item?.landInfo?.owners?.[0]?.name);
    Digit.SessionStorage.set("FASTPAS_ID", item);
    Digit.SessionStorage.set("FILE_NO", item?.applicationNo);
    history.push({
      pathname: `/digit-ui/citizen/obps/structuralform12/${item?.applicationNo}`,
    });
  };

  const closeModal2 = (item) => {
    Digit.SessionStorage.set("FILE_NO", item?.applicationNo);
    Digit.SessionStorage.set("OWNER_INFO", item?.landInfo?.owners?.[0]?.name);
    if (item?.applicationType === "FORM_COMPOUNDING") {
      setIdData(item?.applicationNo);
      setFormType("form12");
      if (item?.applicationNo != null) {
        setSmShowMs(true);
      } else {
        console.log("Application Number Null ");
      }
    } else {
      console.log("all", item);
    }

    // anchorEl(false)
  };

  const viewModal = (item) => {
    if (item?.applicationnumber) {
      setIdData(item?.applicationnumber);
      setshowMs(true);
    }
  };

  // if (applicationFlow === null) {
  //   return <DepartmentSelector />;
  // }

  return (
    <div>
      {loader && <Loader />}

      <div style={{ margin: "0px 4px" }}>
        <BackButton />
        <PrimaryTabsWrapper>
          {/* Tabs Header */}
          <PrimaryTabs value={tabIndex} onChange={handleTabChange} aria-label="Tab Group" variant="scrollable" scrollButtons="auto">
            <PrimaryTab label="New Applications" />
            <PrimaryTab label="Archive Old Applications" />
          </PrimaryTabs>
        </PrimaryTabsWrapper>

        <div hidden={tabIndex !== 0} style={{ padding: "0px 4px" }}>
          <TableContainer className="citizen-table-container">
            <div style={{ display: "flex", alignItems: "center" }}>
              <caption className="citizen-table-caption .mapsub-my-applications">Compounding - My Applications</caption>
              <div className="combine-tab-panel">
                <span className={selectedAction === "All" ? "active" : ""} onClick={() => handleActionChange("All")} style={{ cursor: "pointer" }}>
                  All
                </span>
                <span
                  className={selectedAction === "Submitted" ? "active" : ""}
                  onClick={() => handleActionChange("Submitted")}
                  style={{ cursor: "pointer" }}
                >
                  Submitted
                </span>
                <span
                  className={selectedAction === "Shortfall" ? "active" : ""}
                  onClick={() => handleActionChange("Shortfall")}
                  style={{ cursor: "pointer" }}
                >
                  Shortfall
                </span>
                <span
                  className={selectedAction === "Reject" ? "active" : ""}
                  onClick={() => handleActionChange("Reject")}
                  style={{ cursor: "pointer" }}
                >
                  Reject
                </span>
                <span
                  className={selectedAction === "Approved" ? "active" : ""}
                  onClick={() => handleActionChange("Approved")}
                  style={{ cursor: "pointer" }}
                >
                  Approved
                </span>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <Button
                  variant="outlined"
                  className="bg-white"
                  startIcon={<FilterListIcon />}
                  onClick={handleOpenColumnFilter}
                  size="small"
                  sx={{
                    height: "27px",
                    fontSize: "12px",
                    borderColor: "rgb(31, 74, 124)",
                    color: "rgb(31, 74, 124)",
                  }}
                >
                  {t("FASTPAS.GLOBAL.FILTERS.TEXT")}({selectedColumns.length}/{allColumns.length})
                </Button>
                <TextField
                  variant="outlined"
                  size="small"
                  placeholder="Search here..."
                  value={globalSearch}
                  onChange={(e) => handleGlobalSearch(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon sx={{ background: "#1f4a7c", color: "#fff", height: "24px", borderRadius: "7px 0px 0px 7px", width: "29px" }} />
                      </InputAdornment>
                    ),
                    endAdornment: globalSearch && (
                      <InputAdornment position="end">
                        <IconButton size="small" onClick={() => handleGlobalSearch("")}>
                          <ClearIcon fontSize="small" />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    padding: "0px",
                    height: "25px", // sets outer height
                    "& .MuiInputBase-root": {
                      height: "27px",
                      padding: "0px",
                      backgroundColor: "#fff",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "rgb(31, 74, 124)",
                    },
                    "& .MuiOutlinedInput-input": {
                      padding: "0", // top/bottom padding controls the internal height
                      fontSize: "12px",
                    },
                  }}
                />
              </div>
            </div>
            <Popover
              open={Boolean(anchorEl)}
              anchorEl={anchorEl}
              onClose={handleCloseColumnFilter}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
            >
              <div className="select-column-popover">
                <Typography variant="subtitle2" gutterBottom>
                  Select Columns to Display
                </Typography>
                <FormControlLabel
                  control={
                    <Checkbox
                      sx={{ padding: "0px" }}
                      checked={selectedColumns.length === allColumns.length}
                      indeterminate={selectedColumns.length > 0 && selectedColumns.length < allColumns.length}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedColumns(allColumns.map((col) => col.id));
                        } else {
                          // Optionally, keep at least one column selected
                          setSelectedColumns([allColumns[0].id]);
                        }
                      }}
                    />
                  }
                  sx={{ margin: "0px", fontWeight: "bold" }}
                  label="Select All"
                />
                {allColumns.map((column) => (
                  <div key={column.id}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          sx={{ padding: "0px" }}
                          checked={selectedColumns.includes(column.id)}
                          onChange={() => handleColumnToggle(column.id)}
                          disabled={column.id === "srNo" && selectedColumns.length === 1}
                        />
                      }
                      sx={{ margin: "0px" }}
                      label={column.label}
                    />
                  </div>
                ))}
              </div>
            </Popover>
            <Table stickyHeader aria-label="sticky table" className="citizen-application-table">
              <thead>
                <tr className="citizen-header-row">
                  {columns.map((column) => (
                    <td key={column.id} display="flex" alignItems="center">
                      {column.label}
                      {column.sortable && (
                        <TableSortLabel
                          active={orderBy === column.id}
                          direction={orderBy === column.id ? order : "asc"}
                          onClick={() => handleSort(column.id)}
                          sx={{
                            color: "white !important", // Force white text
                            "& .MuiTableSortLabel-icon": {
                              opacity: "1 !important", // Force icon to always be visible
                              color: "white !important", // Force white icon
                            },
                            "&:hover": {
                              color: "white !important", // Ensure hover doesn't change color
                            },
                          }}
                          // Force the icon to render even when inactive
                          IconComponent={(props) => (
                            <ArrowDownward
                              {...props}
                              sx={{
                                color: "white !important",
                                opacity: 1, // Ensure icon is always visible
                              }}
                            />
                          )}
                        />
                      )}
                    </td>
                  ))}
                  {/* <td>Resubmit</td>
                    <td>Payment Receipt </td>
                    <td>Objection Letter</td>
                    <td>Proposal Letter</td>
                    <td>Approval Letter </td>
                    <td>Action</td> */}
                </tr>
                <tr>
                  {columns.map((column) => (
                    <td key={`filter-${column.id}`}>
                      {column.filterable && (
                        <TextField
                          variant="standard"
                          size="small"
                          value={filters[column.id] || ""}
                          onChange={(e) => handleFilterChange(column.id, e.target.value)}
                          InputProps={{
                            endAdornment: filters[column.id] && (
                              <InputAdornment position="end">
                                <IconButton size="small" onClick={() => handleClearFilter(column.id)}>
                                  <ClearIcon fontSize="small" />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                          sx={{
                            "& .MuiInput-input": {
                              fontSize: "0.75rem",
                            },
                            width: "100%",
                          }}
                        />
                      )}
                    </td>
                  ))}
                </tr>
              </thead>
              <tbody>
                {paginatedData?.length === 0 ? (
                  <tr>
                    <td colSpan={columns.length + 6} align="center">
                      No records found
                    </td>
                  </tr>
                ) : (
                  paginatedData?.map((item, index) => (
                    <tr hover key={index}>
                      {columns.map((column) => column.renderCell(item, index, page, rowsPerPage))}
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50, 75, 100]}
            component="div"
            count={filteredData?.length || 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
        <div hidden={tabIndex !== 1} style={{ padding: "0px 4px" }}>
          <TableContainer className="citizen-table-container archieve-old-table">
            <Table stickyHeader aria-label="sticky table" className="citizen-application-table">
              <thead>
                <tr>
                  <th style={{ width: "5%" }}>Sr No</th>
                  <th style={{ width: "20%" }}>Owner Name</th>
                  <th style={{ width: "25%" }}>Owner Mobile Number</th>
                  <th style={{ width: "25%" }}>Application Number</th>
                  <th style={{ width: "25%" }}>View Summary</th>
                </tr>
              </thead>
              <tbody>
                {migratedData?.map((item, index) => {
                  return (
                    <tr key={item?.applicationNo}>
                      <td>{index + 1}</td>
                      <td>{item?.applicationdetails?.data?.ownerDetail?.ownerName}</td>
                      <td>{item?.applicationdetails?.data?.ownerDetail?.ownerContactNo}</td>
                      <td
                        style={{
                          textDecoration: "underline blue 1px",
                          cursor: "pointer",
                          border: "1px solid #ddd",
                          padding: "8px",
                        }}
                        onClick={() => {
                          window.localStorage.setItem("ApplicationStatus", item?.status);
                          history.push({
                            pathname: `/digit-ui/citizen/obps/structuralform12/${item?.applicationnumber}`,
                          });
                        }}
                      >
                        {item?.applicationnumber}
                      </td>
                      <td>
                        <Button
                          size="small"
                          sx={{ ml: 1, fontSize: "10px", alignContent: "center", display: "flex" }}
                          variant="contained"
                          color="success"
                          onClick={() => viewModal(item)}
                        >
                          <span>View</span>
                        </Button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50, 75, 100]}
            component="div"
            count={10}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </div>
      {showMs && (
        <DialogContentModal
          title={"Application Details"}
          dataOpen={showMs}
          onClose={() => {
            setshowMs(false);
          }}
        >
          <MigratedSummary id={idData} />
        </DialogContentModal>
      )}
      {smShowMs && (
        <DialogContentModal
          title={"Application Details"}
          dataOpen={smShowMs}
          onClose={() => {
            setSmShowMs(false);
          }}
        >
          <SearchSummary id={idData} />
        </DialogContentModal>
      )}
    </div>
  );
};

export default CompoundingApplications;
